<template>
	<div id="sector-tooltip" class="card-body p-2" v-show="show">
		<div class="row mb-2">
			<div class="col">
				<h6>{{ activeSector.name }} Sector</h6>
				<small>{{ tile.name }}</small>
			</div>
			<div class="col text-center align-middle"><div class="coords p-1">{{ coords.x }}, {{ coords.y }}</div></div>
		</div>
		<div class="row">
			<div class="col"><span>{{ activeSector.location }}</span></div>
			<div class="col text-center"><i class="fa fa-globe"></i> {{ activeSector.rank }}<sup>{{ numberToSuper(activeSector.rank) }}</sup></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SectorTooltip",
	props: {
		activeSector: {
			type: Object,
			required: true
		},
		tile: {
			type: Object,
			required: true
		},
		coords: {
			type: Object,
			required: true
		},
		mouse: {
			//
		}
	},
	data() {
		return {
			show: false
		}
	},
	watch: {
		mouse: function () {
			this.show = true;
			const elem = document.getElementById("sector-tooltip")
			elem.style.top = (this.mouse.clientY) + "px";
			elem.style.left = (this.mouse.clientX) + "px";
		}
	},
	methods: {
		//return the superscript of a given number
		numberToSuper(num) {

			if (num >= 20)
				num = num % 10;

			if (num === 0)
				return "th";
			if (num === 1)
				return "st"
			if (num === 2)
				return "nd"
			if (num === 3)
				return "rd"
			if (num >= 4)
				return "th"
		},
	}
}
</script>

<style scoped>

h6 {
	text-align: left;
	font-weight: bold;
	margin-bottom: 0;
}

small {
	color: grey;
}

.ranking {
	text-align: right;
}

.info-row {
	font-size: 0.7em;
}

#sector-tooltip {
	pointer-events: none;
	user-select: none;
	position: absolute;
	z-index: 9;
	width: 300px;
	/*height: 50px;*/
	background: rgba(255, 255, 255, 0.7);
	color: black;
	border-radius: 9px;
	text-align: left;
	font-size: 0.8em;

	margin-top: -100px;
	margin-left: -100px;

	overflow: hidden;
}

.coords {
	border: 1px solid black;
	border-radius: 9px;
	font-weight: bolder;
}

.coords {
	background: #00a8ff;
	color: white;
}

p {
	font-size: 0.7em;
	margin-bottom: 0;
}
</style>